import { render, staticRenderFns } from "./SelectCourseMenu.vue?vue&type=template&id=456f5a7b&"
import script from "@/scripts/Bookmark/components/SelectCourseMenu.js?vue&type=script&lang=js&"
export * from "@/scripts/Bookmark/components/SelectCourseMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports